import { FC } from "react";
import { Path, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdLink: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 19 19" fill="none" {...props}>
    <Path // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      focusable={false}
      d="M8.5 11.3 4.7 7.4 12 0l6.4 6.4L15 9.8l-.7-.7L17 6.4l-5-5-5.9 6 3.1 3.2-.7.7Z"
      fill="currentColor"
    />
    <Path // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      focusable={false}
      d="M6.4 18.5 0 12.1l3.4-3.5.7.7-2.7 2.8 5 4.9 5.9-5.9-3.2-3.2.8-.7 3.8 3.9-7.3 7.4Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdLink;
